
import { defineComponent, ref, reactive, toRefs, inject, unref, onMounted, onUnmounted } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import * as Yup from "yup";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Modal } from "bootstrap";
import VOtpInput from "vue3-otp-input";
import AOS from "aos";
import StorageService from "@/core/services/StorageService";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    flatPickr,
    ErrorMessage
  },
  setup(props, context) {
    const helpers: any = inject("helpers");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const i18n = useI18n();
    const { t } = useI18n();
    let formRef = ref<HTMLElement | null>(null);
    const registerPayload: any = StorageService.getStorageService("REGISTER_PAYLOAD");


    const state = reactive({
      nationalities: [],
      login_method: "phone",
      ImageModel: null,
      ImageLoaderProgress: 0,
      ImageLoader: false,

      first_name: null,
      middle_name: null,
      last_name: null,
      insideEgypt: 0,
      ssn: null,
      phone: null,
      email: null,
      password: null,
      dob: "",
      gender: "male",
      nationality: "",
      governorate: "",
      image: ""
    });

    onUnmounted(() => {

    });

    onMounted(() => {
      AOS.init();
      store.dispatch("moduleCommon/getCountries", {}).then((data) => {
        state.nationalities = data.data
      });
      if (registerPayload) {
        state.phone = (registerPayload.phoneNumber);
        state.ssn = (registerPayload.nationalId);
        state.insideEgypt = (registerPayload.insideEgypt);
        state.email = (registerPayload.email);
        state.login_method = (registerPayload.login_method);
        let token: any = route.params.token;
        window.localStorage.setItem("id_token", token);
        return;
      } else {
        helpers.errorNotify(t("error"), t("error_msg"));
        router.push({ name: "login_page" });
      }
    });

    const submitButton = ref<HTMLElement | null>(null);

    //Form submit function
    const onSubmitLogin = (values, form) => {
      if (!form) {
        return;
      }


      const { setErrors } = form;


      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "true");
      }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        let payload = {
          "email": state.email,
          "personalInformation": {
            "firstName": state.first_name,
            "middleName": state.middle_name,
            "lastName": state.last_name,
            "image": state.image,
            "countryCode": "20",
            "phoneNumber": state.phone,
            "password": state.password,
            "dob": state.dob,
            "nationality": state.nationality,
            "gender": state.gender
          },
          "password": state.password
        };
        store
          .dispatch("moduleAuth/register", payload)
          .then((response) => {
            helpers.successNotify(t("success"), t("success_msg"));
            router.push({ name: "all_programs_page" }).then(() => {

              StorageService.destroyStorageService("REGISTER_PAYLOAD");
            });
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          })
          .catch((response) => {
            if (!helpers) {
              return;
            }
            helpers.handleResponse(response, t, router, store, { setErrors });
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          });

      }, 1000);
    };


    const triggerClickUpdate = () => {
      let element = document.getElementById("imageFile");
      if (element) element.click();
    };
    const handleChangeImage = (evt: Event | any) => {
      let file = evt.target.files[0];
      let payload = new FormData();
      payload.append("path", "UserProfile");
      payload.append("isPublic", "false");
      if (helpers.getUserId()) payload.append("userId", helpers.getUserId());
      payload.append("files", file);
      state.ImageModel = file;
      uploadImage(payload);
    };
    const uploadImage = (payload) => {
      state.ImageLoader = true;
      state.ImageLoaderProgress = 0;
      let config: any = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function(progressEvent) {
          let uploadPercentage: number = (Math.round(((progressEvent.loaded / progressEvent.total) * 100)));
          state.ImageLoaderProgress = uploadPercentage;
        }
      };
      let requestData = {
        formData: payload,
        config: config
      };
      setTimeout(() => {
        store.dispatch("moduleCommon/uploadImage", requestData).then(({ data }) => {
          state.ImageLoader = false;
          // state.image = data.image.path;
          if (data.filesUrls[0]) {
            // state.image = (new URL(data.filesUrls[0])).pathname;
            const queryString = (new URL(data.filesUrls[0])).search;
            const urlParams = new URLSearchParams(queryString);
            let filePath: any = urlParams.get("filePath");
            state.image = filePath;
          }
          setTimeout(() => {
            state.ImageLoaderProgress = 0;
          }, 1000);
        }).catch((response) => {
          state.ImageLoader = false;
          state.ImageLoaderProgress = 0;
          helpers.handleResponse(response, i18n.t, router, store);
        });
      }, 10);
    };

    return {
      triggerClickUpdate,
      handleChangeImage,
      ...toRefs(state),
      onSubmitLogin, i18n, store,
      formRef,
      submitButton
    };
  }
});
